import { useOnlineStatus } from '../../hooks/useOnlineStatus';

/**
 * ⑦ オフライン対応: 通信できない間、画面上部に固定表示する。
 * アプリシェル自体はService Workerでプリキャッシュ済みなので、オフライン
 * でも画面は開けるが、Google Calendarとの通信（GET/POST/PATCH/DELETE）は
 * 行えないため、そのことが分かるようにするだけの控えめな通知バー。
 */
export default function OfflineBanner() {
  const online = useOnlineStatus();
  if (online) return null;

  return (
    <div className="offline-banner" role="status">
      📡 オフラインです
    </div>
  );
}
